"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDailyWorkingHours_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserSpecificHours_1 = require("./UserSpecificHours");
var UserDailyWorkingHours_Factory = /** @class */ (function () {
    function UserDailyWorkingHours_Factory() {
    }
    UserDailyWorkingHours_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            EndTime: Date_Factory_1.Date_Factory.CreateIncoming(model.EndTime),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            StartTime: Date_Factory_1.Date_Factory.CreateIncoming(model.StartTime),
            UserSpecificHours: UserSpecificHours_1.UserSpecificHours_Factory.CreateIncoming(model.UserSpecificHours),
            UserSpecificHoursId: model.UserSpecificHoursId,
            WorkingDayId: model.WorkingDayId,
        };
        return result;
    };
    UserDailyWorkingHours_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            EndTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.EndTime),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            StartTime: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartTime),
            UserSpecificHours: UserSpecificHours_1.UserSpecificHours_Factory.CreateOutgoing(model.UserSpecificHours),
            UserSpecificHoursId: model.UserSpecificHoursId,
            WorkingDayId: model.WorkingDayId,
        };
        return result;
    };
    return UserDailyWorkingHours_Factory;
}());
exports.UserDailyWorkingHours_Factory = UserDailyWorkingHours_Factory;
